import { render, staticRenderFns } from "./YearCharacter.vue?vue&type=template&id=46051b75&"
import script from "./YearCharacter.vue?vue&type=script&lang=js&"
export * from "./YearCharacter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports